export const SanDiegoData = [
  {
    title: "Birth Certificate",
    detail:
      "Birth certificate translation may be necessary for your applications. If you need a birth certificate translation, Tomedes can certify translations for application in private and public institutions.",
    link: "/birth-certificate-translation.php",

    subTitle: " Translation",
  },
  {
    title: "Immigration ",
    detail:
      "For immigrants, translation of documents may make or break an application. Tomedes can certify your documents for acceptance in the United States Citizenship and Immigration Services (USCIS).",
    link: "/uscis-translation-services",
    subTitle: "Translation",
  },
];

export const LanguagesInSanDiego = [
  {
    heading: "Spanish",
    detail:
      "Tomedes' Spanish translation services are 23% of the overall population, making Spanish a major language spoken in San Diego. In order to utilize your market potential in San Diego, you may have to make a mark with translations from Spanish to English or any other language. Get started with us today.",
    link: "/spanish-translation.php",
  },
  {
    heading: "German",
    detail:
      "In San Diego, 11,000 people speak German. For industries in San Diego, German may be a huge asset to any business. Tomedes can support English to German translation, and vice versa. There's also 120 languages you can choose from for your business.",
    link: "/german-translation.php",
  },
  {
    heading: "Russian",
    detail:
      "About 8,000 people speak Russian in San Diego, making Russian communities important to access for any business. Accessing this demographic may be made easier through English to Russian translation, or vice versa. Choose from over 120 languages to translate Russian from and into today.",
    link: "/russian-translation.php",
  },
  {
    heading: "Japanese",
    detail:
      "There's a population of 35,000 Japanese speaking people living in San Diego. Tomedes makes sure a native Japanese translator will translate your documents, and other relevant translation services. Tomedes knows your Japanese to English and English to Japanese translations need to be accurate. Why not get started today?",
    link: "/japanese-translation.php",
  },
];
